import Checked from '../Icon/EditorDoneIcon.js';

//
var script = {
  name: 'CheckboxRenderer',
  components: {
    Checked
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/CheckboxRenderer.vue_rollup-plugin-vue=script.js